import { lazy } from "react";

export const ResponseMessage = lazy(() => import("./ResponseMessage"));
